export default __webpack_public_path__ + "static/media/5.d2af2907.jpg";